<div class="u-shadow-mini pos-relative">
	<app-loader [showLoader]="showLoad"></app-loader>
	<div class="c-portlet_box_specs">
		<div *ngIf="!hasData">
			<div class="creative-title">
				<h5>{{ sectiontitle }}</h5>
			</div>
			<div class="parameters-div" style="padding: 15px 20px">No data found</div>
		</div>

		<div *ngIf="hasData">
			<div class="creative-title">
				<h5 [title]="currentCreativeData?.creativeName">
					{{ sectiontitle }} : {{ currentCreativeData?.creativeName }}
				</h5>
				<!-- *ngIf="totalCreatives!=0 && downloadConfiguration && downloadConfiguration.enableDownload" -->
				<a href="#" class="datatable_download_icon" (click)="downloadDataInCSV($event)" target="_blank">
					<i class="fa fa-download" aria-hidden="true"></i>
				</a>
			</div>

			<div class="carousel-area">
				<div class="creative-performance-stats">
					<ngu-carousel #carousel [inputs]="carouselOne" [dataSource]="sortedCreatives">
						<ngu-tile NguCarouselItem *nguCarouselDef="let creativeData">
							<app-creative-performance-stats
								[creative]="creativeData"
								[sectionclass]="sectionclass"
							></app-creative-performance-stats>
						</ngu-tile>
						<button NguCarouselPrev class="leftRs">&lt;</button>
						<button NguCarouselNext class="rightRs">&gt;</button>
						<ul class="carousel-points-container myPoint" NguCarouselPoint>
							<li
								*ngFor="let j of carousel.pointNumbers; let k = index"
								[class.active]="j == carousel.activePoint"
								(click)="moveToSelectedCarousel(k)"
							></li>
						</ul>
					</ngu-carousel>
				</div>
			</div>
			<div class="parameters-div">
				<div *ngFor="let stat of currentStats; let i = index" class="stats-div">
					<div [ngClass]="i % 2 != 0 ? 'odd-div' : 'even-div'">
						<div class="param-name display-stats">{{ stat.name }}</div>
						<div class="param-val display-stats">
							<span *ngIf="stat.hasPercent"> {{ stat.percent_value }} &nbsp;&nbsp;&nbsp;&nbsp; |</span>
						</div>
						<div class="param-val display-stats">
							<span *ngIf="stat?.value">{{ stat?.value | formatNumber }} </span><span *ngIf="!stat?.value">--</span>
						</div>
						<br class="clearBoth" />
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
